<template>
  <div style="padding: 10px 30px;">
    <a-alert
      v-if="userDetail.change_password_required"
      message="Password Change Required"
      description="You must change your password before you can access the portal"
      type="error"
    />
    <a-button class="password-button" type="primary" @click="showModal">
      <span v-if="userDetail.username && userDetail.username != this.$store.state.user.data.username">Change password for {{userDetail.username}}</span>
      <span v-else>Change password</span>
    </a-button>
    <a-modal
            title="Change Password"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="onSubmit"
            @cancel="handleCancel"
    >
      <a-form :form="changePasswordForm">
        <div class="a-body p-20-px flex-grow-1">
          <a-row :gutter="20">
            <a-col :span="12">
              <a-form-item label="Email">
                <a-input v-model="userDetail.username" disabled type="email"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Old Password" class="password" :validate-status="formServerErrors.old_password.status" :help="formServerErrors.old_password.help">
                <a-input-password
                        v-decorator="[
                          'oldPassword',
                          {
                            rules: [
                              { required: true, message: 'Please input Old Password!' }
                            ]
                          }
                        ]"
                        type="password"
                        placeholder="Old Password"
                >
                </a-input-password>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="12">
              <a-form-item label="New Password" class="password" :validate-status="formServerErrors.new_password.status" :help="formServerErrors.new_password.help">
                <a-input-password
                        v-decorator="[
                          'newPassword',
                          {
                            rules: [
                                { required: true, message: 'Please input New Password!' }
                            ]
                          }
                        ]"
                        type="password"
                        placeholder="Password"
                >
                </a-input-password>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Confirm Password" class="password">
                <a-input-password
                        v-decorator="[
                          'confirmPassword',
                            {
                            rules: [
                              { validator: validatorConfirmPassword },
                              {
                              required: true,
                              message: 'Please input Confirm Password!'
                              }
                            ]
                          }
                        ]"
                        type="password"
                        placeholder="Confirm Password"
                >
                </a-input-password>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>


<script>
  import {
    debounceTimeExecute,
    flatMapErrMessagesValidateForm,
  } from "@shared/helpers/utils";
  import AccountService from '../services/account.service';
  import Vue from "vue";
  import ApiService from "../../../shared/services/api.service";

  export default {
    name: 'ChangePassword',
    data() {
      return {
        visible: false,
        confirmLoading: false,
        userDetail: {
          username: "",
        },
        formServerErrors: {
          old_password: {
            status: null,
            help: null,
          },
          new_password: {
            status: null,
            help: null,
          },
        }
      }
    },
    beforeCreate() {
      this.changePasswordForm = this.$form.createForm(this, {
        name: 'normal_reset'
      });
      this.active2FAForm = this.$form.createForm(this, {
        name: "normal_activate2fa",
      });
    },
    mounted() {
      this.initData();
    },
    methods: {
      async initData() {
        const userDetail = await AccountService.getUser();
        this.userDetail = {
          ...userDetail,
          change_password_required: !!userDetail.force_change_password_on_login,
          enable_2fa: !!userDetail.enable_2fa,
        };
      },

      onSubmit(e) {
        e.preventDefault();

        this.confirmLoading = true;

        // Reset error status
        this.formServerErrors = {
          old_password: {
            status: null,
              help: null,
          },
          new_password: {
            status: null,
              help: null,
          },
        };

        this.changePasswordForm.validateFields((err, values) => {
          const errors = this.errorList();
          if (errors.length > 0) {
            this.$showErrorMessage(errors[0]);
            return;
          }
          const params = {
            old_password: values.oldPassword,
            new_password: values.newPassword
          };
          if (!err) {
            AccountService.changePassword(params).then((data) => {
              if (data) {
                this.changePasswordForm.resetFields();
                this.$showSuccessMessage(data);
                // Hide the modal box if password changed successfully
                this.visible = false;
                // Update the user data so that any force password change messages are removed
                this.initData();
              }
            }).catch((serverErr) => {
              if( serverErr.response && serverErr.response.data && serverErr.response.data.errors){
                console.log(serverErr.response.data.errors); // => the response payload
                for(const fieldname in serverErr.response.data.errors) {
                  this.formServerErrors[fieldname].status = "error";
                  this.formServerErrors[fieldname].help = serverErr.response.data.errors[fieldname].join("\n");
                }
              }
            }).then(() => {
              this.confirmLoading = false;
            });
          }
        });
      },

      validatorConfirmPassword(rule, value, callback) {
        const form = this.changePasswordForm;
        if (!value) {
          callback();
          return;
        }

        if (value !== form.getFieldValue('newPassword')) {
          callback('Two passwords that you entered is inconsistent!');
        } else {
          callback();
        }
      },

      errorList() {
        const errors = [];

        if (this.changePasswordForm.getFieldValue('newPassword') != this.changePasswordForm.getFieldValue('confirmPassword')) {
          errors.push('Your password and confirmation password do not match.');
        }
        return errors;
      },

      isFormInvalid() {
        if (!this.changePasswordForm) {
          return true;
        }
        return !this.changePasswordForm.getFieldValue('newPassword') || !this.changePasswordForm.getFieldValue('confirmPassword') || !!this.changePasswordForm.getFieldError('newPassword') || !!this.changePasswordForm.getFieldError('confirmPassword');
      },

      showModal() {
        this.visible = true;
      },

      handleCancel(e) {
        this.visible = false;
      },
    }
  }

</script>

<style lang="scss" scoped>
  .change-password-page {
    .ant-form label::before {
      display: none;
    }

    .a-footer .ant-btn {
      min-width: 120px;
    }
  }

  .password-button {
    border-radius: 4px;
    cursor: pointer;
    line-height: 21px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 14px;
    text-align: center;
    -webkit-appearance: none;
    white-space: nowrap;
    -moz-appearance: none;
    appearance: none;
  }
</style>
